/* MAIN MENU DRAWER */

document.addEventListener("DOMContentLoaded", () => {
  const initFooterVideo = () => {
    const footerVideoConainter = document.querySelector(
      ".main-menu__footer__video"
    );
    const footerVideo = footerVideoConainter.querySelector("video");
  
    if (!footerVideo) {
      return;
    }
  
    const muteButton = footerVideoConainter.querySelector('[data-action="mute"]');
    const unmuteButton = footerVideoConainter.querySelector(
      '[data-action="unmute"]'
    );
  
    muteButton.addEventListener("click", () => {
      footerVideo.muted = true;
      muteButton.hidden = true;
      unmuteButton.hidden = false;
    });
  
    unmuteButton.addEventListener("click", () => {
      footerVideo.muted = false;
      muteButton.hidden = false;
      unmuteButton.hidden = true;
    });
  }

  const initAnnouncementBarHeight = () => {
    const announcementBar = document.querySelector('.announcement-bar');
    if (!announcementBar) {
      return;
    }

    const announcementBarSlot = document.querySelector('.main-menu-drawer__announcement-bar');
    
    document.addEventListener('main-menu-drawer:open', () => {
      const clientRect = announcementBar.getBoundingClientRect();
      announcementBarSlot.style.height = `${clientRect.y + clientRect.height}px`;
    });
  }

  initFooterVideo();
  initAnnouncementBarHeight();
});

/* Product Options */

const createImage = (url, size, thumbnail = false) => {
  const widths = thumbnail ? [200] : [
    200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000,
  ];
  return `<img srcset="${widths
    .map((w) => `${url}&width=${w} ${w}w`)
    .join(",")}" width="${size}" height="${size}"
     loading="lazy" fetchpriority="auto" sizes="(max-width: 699px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), calc(68vw - 96px)" class=" aspect-1/1">`;
};

function handleProductOptions() {
  const formId = document.querySelector("#formId")
    ? JSON.parse(document.querySelector("#formId").innerHTML)
    : null;
  if (!formId) return;

  const form = document.querySelector(`#${formId}`);
  const submitBtn = form.querySelector('button[type="submit"]');

  const productJson = document.querySelector("[data-product-json]")?.innerHTML;
  if (!productJson) {
    return;
  }

  const productData = JSON.parse(productJson);

  const initialVariantId = form.querySelector("input[name=id]").value;
  const initailVariant = productData.variants.find(
    (variant) => variant.id == initialVariantId
  );

  let selectedOptions = {
    option1: initailVariant.option1,
    option2: initailVariant.option2,
    option3: initailVariant.option3,
  };


  const afterOptionChange = (currentVariant) => {
    document.dispatchEvent(new CustomEvent("dialog:close-all"));

    form.querySelector("input[name=id]").value = currentVariant.id;
    submitBtn.textContent = window.themeVariables.strings.addToCartButton;
    submitBtn.disabled = false;

    if (currentVariant?.featured_image) {
      const mainPictureContainer = document.querySelector(
        ".product-gallery__media"
      );
      mainPictureContainer.innerHTML = createImage(
        currentVariant.featured_image.src,
        2000
      );
    }

    document.dispatchEvent(
      new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          product: productData,
          variant: currentVariant,
        },
      })
    );

    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
    const salePrices = document.querySelectorAll("sale-price[form]");
    const compareAtPrices = document.querySelectorAll("compare-at-price[form]");

    salePrices.forEach((sp) => {
      sp.textContent = formatMoney(currentVariant.price, currencyFormat);
    });

    compareAtPrices.forEach((cap) => {
      cap.textContent = formatMoney(
        currentVariant.compare_at_price,
        currencyFormat
      );
    });

    const newUrl = new URL(window.location.href);
    if (currentVariant.id) {
      newUrl.searchParams.set("variant", currentVariant.id);
    } else {
      newUrl.searchParams.delete("variant");
    }
    window.history.replaceState(
      { path: newUrl.toString() },
      "",
      newUrl.toString()
    );
  }

  const onOptionChangeSwatches = (changedInput) => {
    const optionButtons = document.querySelectorAll("[data-option-button]");
    const currentVariant = productData.variants.find(
      (variant) =>
        variant.option1 == selectedOptions.option1 &&
        variant.option2 == selectedOptions.option2 &&
        variant.option3 == selectedOptions.option3
    );

    optionButtons.forEach((btn) => {
      btn.classList.add("option-selector--active");
      const image = btn.querySelector("[data-image]");
      const value = btn.querySelector("[data-value]");

      value.textContent = selectedOptions[`option${btn.dataset.optionButton}`];
      if (currentVariant?.featured_image) {
        image.innerHTML = createImage(currentVariant.featured_image.src, 48);
      }
    });

    const optionGroups = document.querySelectorAll(".option-group[data-option]");
    optionGroups.forEach((optionGroup) => {
      if (optionGroup.dataset.option != changedInput.dataset.option) {
        const inputs = optionGroup.querySelectorAll("input");

        inputs.forEach((input) => {
          const variant = productData.variants.find(
            (variant) =>
              variant[`option${changedInput.dataset.option}`] == changedInput.value &&
              variant[`option${optionGroup.dataset.option}`] == input.value
          );
          input.disabled = !variant;

          if (variant) {
            const priceElement = input.nextElementSibling.querySelector('[data-variant-price]');
            if (priceElement) {
              priceElement.textContent = formatMoney(variant.price);
            }
          }

          if (variant?.featured_image && !optionGroup.classList.contains('option-color-swatches')) {
            const image =
              input.nextElementSibling.querySelector("[data-image]");
            image.innerHTML = createImage(variant.featured_image.src, 48);
          }
        });
      }

      if (optionGroup.classList.contains('option-color-swatches') && !changedInput.parentElement.classList.contains('option-picker-drawer__options')) {
        const nameLabel = optionGroup.parentElement.querySelector(`[data-option-name="${optionGroup.dataset.option}"]`);
        nameLabel.dataset.current = changedInput.value;
        nameLabel.textContent = changedInput.value;
      }
    });

    afterOptionChange(currentVariant);
  }

  const onOptionChange = (changedInput) => {
    const currentVariant = productData.variants.find(
      (variant) =>
        variant.option1 == selectedOptions.option1 &&
        variant.option2 == selectedOptions.option2 &&
        variant.option3 == selectedOptions.option3
    );

    const optionGroups = document.querySelectorAll(".option-group[data-option]");
    optionGroups.forEach((optionGroup) => {
      const allGroupInputs = document.querySelectorAll('input[data-option]');
      const checkedValues = Array.from(allGroupInputs)
        .filter(i => i.checked)
        .map(i => i.value);
      
      const variant = productData.variants.find(
        (variant) => variant.options.every(option => checkedValues.includes(option)));
        
      const inputs = optionGroup.querySelectorAll("input");
      const checkedInput = Array.from(inputs).find(i => i.checked);
      let thumbnailSrc = checkedInput.labels[0].querySelector('img').src || checkedInput.labels[0].querySelector('img').srcset.split(' ')[0];

      const btn = document.querySelector(`[data-option-button="${optionGroup.dataset.option}"]`);
      const image = btn.querySelector("[data-image]");
      const value = btn.querySelector("[data-value]");
      value.textContent = selectedOptions[`option${btn.dataset.optionButton}`];

      if (optionGroup.dataset.optionName != 'color' && variant.featured_image) {
        thumbnailSrc = variant.featured_image.src;
      }

      if (thumbnailSrc) {
        image.innerHTML = createImage(thumbnailSrc, 48, true);
      }

      if (optionGroup.dataset.option != changedInput.dataset.option) {
        inputs.forEach((input) => {
          const variant = productData.variants.find(
            (variant) =>
              variant[`option${changedInput.dataset.option}`] == changedInput.value &&
              variant[`option${optionGroup.dataset.option}`] == input.value
          );
          input.disabled = !variant;

          if (variant) {
            const priceElement = input.nextElementSibling.querySelector('[data-variant-price]');
            if (priceElement) {
              priceElement.textContent = formatMoney(variant.price);
            }
          }

          if ("featured_image" in variant && optionGroup.dataset.optionName != 'color' && !optionGroup.classList.contains('option-color-swatches')) {
            const image =
              input.nextElementSibling.querySelector("[data-image]");
            image.innerHTML = createImage(variant.featured_image.src, 48, true);
          }

          if (optionGroup.classList.contains('option-color-swatches')) {
            const nameLabel = optionGroup.parentElement.querySelector(`[data-option-name="${optionGroup.dataset.option}"]`);
            nameLabel.dataset.current = changedInput.value;
            nameLabel.textContent = changedInput.value;
          }
        });
      }
    });
    
    afterOptionChange(currentVariant);
  };

  const optionGroups = document.querySelectorAll(".option-group[data-option]");
  optionGroups.forEach((optionGroup) => {
    const optionInputs = optionGroup.querySelectorAll("input");

    optionInputs.forEach((input) => {
      if (input.checked) {
        selectedOptions[`option${optionGroup.dataset.option}`] = input.value;
      }

      if (optionGroup.classList.contains('option-color-swatches')) {
        const nameLabel = optionGroup.parentElement.querySelector(`[data-option-name="${optionGroup.dataset.option}"]`);

        input.labels[0]?.addEventListener('mouseenter', () => {
          nameLabel.textContent = input.value;
        });
        input.labels[0]?.addEventListener('mouseleave', () => {
          nameLabel.textContent = nameLabel.dataset.current;
        });
      }

      input.addEventListener("change", () => {
        selectedOptions[`option${optionGroup.dataset.option}`] = input.value;

        const blockItem = document.querySelector('[data-block-type="variant-picker"]');
        const swatches = blockItem.querySelector('.option-color-swatches');

        window.scrollTo({ top: 0, behavior: "smooth" });

        if (swatches) {
          onOptionChangeSwatches(input);
          return;
        }

        onOptionChange(input);
      });
    });
  });
}
handleProductOptions();

const changePriceListValues = () => {
  document.addEventListener("variant:change", (event) => {
    const salePrice = document.querySelector("sale-price[data-sale-price]");
    const compareAtPrice = document.querySelector(
      "compare-at-price[data-compare-at-price]"
    );

    const variant = event.detail.variant;

    salePrice.textContent = formatMoney(
      variant.price,
      window.themeVariables.settings.moneyFormat
    );

    compareAtPrice.textContent = formatMoney(
      variant.compare_at_price,
      window.themeVariables.settings.moneyFormat
    );

    // Check if compare_at_price is greater than or equal to price
    if (variant.compare_at_price > variant.price) {
      compareAtPrice.hidden = false; // Show compareAtPrice
    } else {
      compareAtPrice.hidden = true; // Hide compareAtPrice
    }
  });
};
changePriceListValues();

/* Color Sample Upsell */
class ColorSampleUpsellElement extends HTMLElement {
  connectedCallback() {
    this.upsellButton = this.querySelector("[data-color-sample-upsell");

    if (!this.upsellButton) {
      console.warn("No upsell button located in element");
      return;
    }

    this.AddEventListeners();
  }

  disconnectedCallback() {
    this.RemoveEventListeners();
  }

  AddEventListeners() {
    this.upsellButton.addEventListener("click", this.AddToCart.bind(this));
  }

  RemoveEventListeners() {
    if (!this.upsellButton) {
      return;
    }
    this.upsellButton.removeEventListener("click", this.AddToCart.bind(this));
  }

  CloseDrawers = () => {
    document
      .querySelectorAll("x-drawer")
      .forEach((drawer) => drawer.removeAttribute("open"));
  };

  GetAndShowCart = (data) => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          onSuccessDo: "force_open_drawer",
          cart: data,
        },
      })
    );
  };

  AddToCart = async () => {
    //this.CloseDrawers();

    const data = {
      id: +this.upsellButton.dataset.id,
      quantity: 1,
    };

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const form = document.querySelector('form[action="/cart/add"]');
    const currentVariantId = form.querySelector('input[name="id"]');
    const sectionId = form.querySelector('input[name="section-id"]');

    return await fetch("/cart/add.js", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify({
        items: [data],
        "section-id": sectionId.value,
        sections_url: `${Shopify.routes.root}variants/${currentVariantId.value}`,
        sections: sectionsToBundle.join(","),
      }),
    })
      .then((response) => {
        return response.json().then(async (data) => {
          if (response.ok) {
            const cartContent = await (
              await fetch(`${Shopify.routes.root}cart.js`)
            ).json();
            cartContent["sections"] = data["sections"];
            this.GetAndShowCart(cartContent);
          } else {
            console.error("Error:", data);
          }
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
}

customElements.define("color-sample-upsell", ColorSampleUpsellElement);

/* Swipers */
import Swiper from "swiper";
document.addEventListener("DOMContentLoaded", () => {
  var productGallerySwiper = new Swiper(".product-gallery-swiper", {
    slidesPerView: 1.07,
    freeMode: true,
    speed: 500,
    spaceBetween: 8,
    breakpoints: {
      700: {
        spaceBetween: 40,
        slidesPerView: 2.5,
      },
    },
  });

  var collectionLinksSwiper = new Swiper(".collection-banner__collection-links", {
    slidesPerView: 'auto',
    freeMode: true,
  });
});

/* Preorder */
const handlePreorderTexts = (container, variant) => {
  const preorderTexts = container.querySelectorAll(".preorder-text");
  preorderTexts.forEach((preorderText) => {
    const defaultText = preorderText.querySelector('[data-id="default"]');

    const children = Array.from(preorderText.children);

    const variantText = children.find(
      (text) => text.dataset.id == variant.id.toString()
    );
    children.forEach((text) => (text.hidden = true));

    if (variantText || defaultText) {
      (variantText || defaultText).hidden = false;
    }
  });
};

document.addEventListener("variant:change", (event) => {
  const productContainer = document.querySelector(".product-info");
  const variant = event.detail.variant;

  handlePreorderTexts(productContainer, variant);
});

/* Preorder end */

/* Section nav */

document.addEventListener("DOMContentLoaded", () => {
  let previousName = "";

  const setSectionNavName = (section) => {
    const nameElements = section.querySelectorAll(".h2", "h2");
    const sectionName = nameElements ? nameElements[0]?.textContent : "";

    if (!!sectionName) {
      previousName = sectionName;
    }

    section.sectionName = sectionName ?? previousName;
  };

  let isScrolling = false;

  const scrollTo = (section, sectionNav) => {
    if (isScrolling) {
      return;
    }

    isScrolling = true;

    const paddingBlockStart = parseFloat(
      window.getComputedStyle(section).paddingTop
    );
    const stickyElementHeight = sectionNav.getBoundingClientRect().height;
    const scrollPosition =
      section.offsetTop - paddingBlockStart - stickyElementHeight - 20;

    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });

    setTimeout(() => {
      if (isScrolling) {
        // Ensure scrolling is still in progress before setting it to false
        isScrolling = false;
      }
    }, 600);
  };

  const sectionNav = document.querySelector("[data-section-nav]");

  if (!sectionNav) {
    return;
  }

  const ignoredSections = [
    ".shopify-section-group-header-group",
    ".shopify-section-group-footer-group",
    ".shopify-section-group-header-group",
    ".shopify-section--footer",
    ".shopify-section--main-menu-drawer",
    ".shopify-section-group-overlay-group",
  ];
  const sections = Array.from(
    document.querySelectorAll(
      `.shopify-section:not(${ignoredSections.join(",")})`
    )
  );

  const navIndex = sections.findIndex((element) =>
    element.classList.contains("shopify-section--section-nav")
  );
  const filteredSections = sections
    .filter((element, index) => index >= navIndex)
    .filter(
      (element) => !element.classList.contains("shopify-section--section-nav")
    );

  filteredSections.forEach(setSectionNavName);

  let navItems = [];

  const setupNavItems = () => {
    const sectionsWithUniqueSectionName = Array.from(
      filteredSections
        .reduce((map, item) => {
          const key = item["sectionName"];
          if (!map.has(key)) {
            map.set(key, item);
          }
          return map;
        }, new Map())
        .values()
    );

    sectionsWithUniqueSectionName.forEach((section, index) => {
      const navButton = document.createElement("button");
      navButton.classList.add("section-nav__item");
      if (index == 0) {
        navButton.classList.add("section-nav__item--active");
      }

      navButton.textContent = section.sectionName;

      navButton.addEventListener("click", () => {
        scrollTo(section, sectionNav);
        navItems.forEach((i) =>
          i.classList.remove("section-nav__item--active")
        );
        navButton.classList.add("section-nav__item--active");
        //navButton.parentElement.scrollTo({ left: navButton.getBoundingClientRect().left });
      });

      sectionNav.appendChild(navButton);
      navItems.push(navButton);
    });
  };

  setupNavItems();

  /* Intersection Observer stuff */

  const debounce = (func, wait) => {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      const later = function () {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const setupIntersectionObserver = () => {
    const options = {
      root: null,
      rootMargin: "0px",
    };

    filteredSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const sectionHeight = rect.bottom - rect.top;
      const sectionHeightPercentage =
        (sectionHeight / window.innerHeight) * 100;

      let threshold = 1.0;
      if (sectionHeightPercentage > 70) {
        threshold = Math.min(0.5, 1 / (sectionHeightPercentage / 100));
      }

      const observerOptions = { ...options, threshold };
      const observer = new IntersectionObserver(
        intersectionCallback,
        observerOptions
      );
      observer.observe(section);
    });
  };

  const intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (!isScrolling && entry.isIntersecting) {
        const activeItem = navItems.find(
          (item) => item.textContent === entry.target.sectionName
        );

        if (activeItem.classList.contains("section-nav__item--active")) return;

        navItems.forEach((i) =>
          i.classList.remove("section-nav__item--active")
        );
        activeItem.classList.add("section-nav__item--active");
        activeItem.parentElement.scrollTo({
          left: activeItem.getBoundingClientRect().left,
        });
      }
    });
  };

  window.addEventListener("resize", () =>
    debounce(setupIntersectionObserver, 200)
  );

  setupIntersectionObserver();
});

/* section nav end */

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
